import { Form } from 'react-bootstrap';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';

type FormCheckInputType = 'checkbox' | 'radio';

interface CheckBoxProps {
  type?: FormCheckInputType;
  label: string;
  name: string;
  valueForm: any;
  required?: boolean;
  errorFeedback?: any;
  onChange?: any;
  onBlur?: any;
  isValid?: any;
  isInvalid?: any;
  tooltip?: string;
}

export const CheckBox: React.FC<CheckBoxProps> = ({
  type = 'checkbox',
  label,
  name,
  valueForm,
  required = false,
  errorFeedback,
  onChange,
  onBlur,
  isValid,
  isInvalid,
  tooltip,
}) => {
  return (
    <Form.Group controlId={name} className="mb-3">
      <Form.Check>
        <Form.Check.Input
          type={type as FormCheckInputType}
          name={name}
          value={'true'}
          checked={valueForm}
          required={required}
          onChange={onChange}
          onBlur={onBlur}
          isValid={isValid}
          isInvalid={isInvalid}
        />
        <Form.Check.Label>
          {label}
          {tooltip && (
            <Tooltip title={tooltip} placement="top">
              <InfoIcon
                style={{
                  marginLeft: '8px',
                  fontSize: '16px',
                  color: '#6c757d',
                  cursor: 'help',
                }}
              />
            </Tooltip>
          )}
        </Form.Check.Label>
        <Form.Control.Feedback type="invalid">{errorFeedback}</Form.Control.Feedback>
      </Form.Check>
    </Form.Group>
  );
};
